const e = {
  base: "adyen-pe-grant-details",
  content: "adyen-pe-grant-details__content",
  header: "adyen-pe-grant-details__header",
  label: "adyen-pe-grant-details__label"
};
export {
  e as GRANT_DETAILS_CLASS_NAMES
};
